export function drawerFormSubmit() {
  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!form.closest(".option-drawer-content")) return;
    if (!form.querySelector('input[name^="SQ_FORM_"]')) return;

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute("aria-busy", "true");
    }

    try {
      const actionUrl = new URL(form.action);
      actionUrl.searchParams.set("SQ_DESIGN_NAME", "blank");

      const formData = new FormData(form);
      if (submitBtn?.name) formData.append(submitBtn.name, submitBtn.value ?? "Submit");

      const res = await fetch(actionUrl.toString(), {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error(`Form submission failed: ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const isSuccess = !doc.getElementById(form.id);

      // Replace only the form element itself, leaving surrounding drawer content intact
      const replacement = document.createElement("div");
      replacement.innerHTML = doc.body.innerHTML;
      form.replaceWith(replacement);

      if (isSuccess) {
        replacement.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // Errors — re-render reCAPTCHA widget if present
        const recaptchaEl = replacement.querySelector(".g-recaptcha");
        if (recaptchaEl && window.grecaptcha) {
          recaptchaEl.innerHTML = "";
          window.grecaptcha.render(recaptchaEl, {
            sitekey: recaptchaEl.dataset.sitekey,
            theme: recaptchaEl.dataset.theme || "light",
            size: recaptchaEl.dataset.size || "normal",
          });
        }
      }
    } catch (err) {
      console.error("Drawer form submission failed:", err);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute("aria-busy");
      }
    }
  });
}
